module.exports = __webpack_public_path__ + "static/holmes-518fcfc17ad0043bd27c80788eccdf47.png";